import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { imagesMicrositeAPIService } from '~/api/microsites/images';
import DEFAULT_IMAGES_0 from '~/assets/icons/DEFAULT_IMAGES_0.png';
import DEFAULT_IMAGES_1 from '~/assets/icons/DEFAULT_IMAGES_1.png';

export const updateImagesSiteThunk = createAsyncThunk(
  'imagesSlice/updateImagesThunk',
  async (body, { rejectWithValue }) => {
    try {
      const response = await imagesMicrositeAPIService.updateImagesSite(body);

      if (body.dispatchHandler) {
        body.dispatchHandler();
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const imagesSlice = createSlice({
  name: 'imagesSlice',
  initialState: {
    title: '',
    bacgkroundColor: ['#5356FF'],
    fonts: {
      title: 'Times New Roman, serif',
      text: 'Times New Roman, serif',
    },
    images: [
      {
        img: DEFAULT_IMAGES_0,
        title: 'mockup',
        path: 'image 1.png',
        size: '242kb',
        file: '',
      },
      {
        img: DEFAULT_IMAGES_1,
        title: 'mockup',
        path: 'image 2.png',
        size: '242kb',
        file: '',
      },
    ],
    imagesType: 'HORIZONTAL',
    imageInformation: {
      header: 'Lorem ipsum dolor',
      description: 'Vestibulum commodo vel risus ac dapibus. Mauris sollicitudin suscipit velit.',
      website: 'https://www.myweb.com',
    },
    buttons: [
      {
        id: 1,
        text: 'SEE MORE',
        url: 'https://example.com',
      },
    ],
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
    },
    loading: false,
    error: null,
    micrositeData: null,
    micrositeStyles: { container: {} },
  },
  reducers: {
    setBackgroundColor(state, action) {
      state.bacgkroundColor = action.payload;
    },
    setFonts(state, action) {
      state.fonts[action.payload.field] = action.payload.value;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
    setImageInformation(state, action) {
      state.imageInformation[action.payload.field] = action.payload.value;
    },
    setImages(state, action) {
      state.images = action.payload;
    },
    setContentImagesValues(state, action) {
      state.images[action.payload.index][action.payload.field] = action.payload.value;
    },
    setImagesType(state, action) {
      state.imagesType = action.payload;
    },
    setButtons(state, action) {
      state.buttons = action.payload;
    },
    setButtonsDetail(state, action) {
      state.buttons[action.payload.index][action.payload.field] = action.payload.value;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setRenderedMicrositeData(state, action) {
      state.title = action.payload.title;
      state.bacgkroundColor = action.payload.bacgkroundColor;
      state.fonts = action.payload.fonts;
      state.images = action.payload.images;
      state.imagesType = action.payload.imagesType;
      state.imageInformation = action.payload.imageInformation;
      state.buttons = action.payload.buttons;
      state.micrositeData = action.payload.micrositeData;
      state.stats = action.payload.stats;
    },
    setMicrositeStyles(state, action) {
      state.micrositeStyles = action.payload;
    },
    resetState: () => imagesSlice.getInitialState(),
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateImagesSiteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateImagesSiteThunk.fulfilled, (state, action) => {
        state.loading = true;
        state.micrositeData = action.payload;
      })
      .addCase(updateImagesSiteThunk.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload;
      });
  },
});

export default imagesSlice.reducer;
